/*         */
import { defineRoute } from "@kestrel/router";
/*         */
import type { LoadContext, Params } from "@kestrel/server";

export const routes = [
    defineRoute({
        path: "/trend",
        component: () => import("./cinemas/StorefrontTrendCinema.svelte"),
        server: () => import("./cinemas/StorefrontTrendCinema.server.ts"),
    }),
    defineRoute({
        path: "/lastseen",
        component: () => import("./cinemas/LastSeenArticlesCinema.svelte"),
        server: () => import("./cinemas/LastSeenArticlesCinema.server.ts"),
    }),
    defineRoute({
        path: "/entrypage",
        component: () => import("./cinemas/EntryPageCinema.svelte"),
        server: () => import("./cinemas/EntryPageCinema.server.ts"),
    }),
    defineRoute({
        path: "/storefront",
        component: () => import("./cinemas/StorefrontCinema.svelte"),
        server: () => import("./cinemas/StorefrontCinema.server.ts"),
    }),
    defineRoute({
        path: "/brand",
        component: () => import("./cinemas/BrandCinema.svelte"),
        server: () => import("./cinemas/BrandCinema.server.ts"),
    }),
    defineRoute({
        path: "/basket",
        component: () => import("./cinemas/BasketCinema.svelte"),
        server: () => import("./cinemas/BasketCinema.server.ts"),
    }),
    defineRoute({
        path: "/alternative",
        component: () => import("./cinemas/AlternativesCinema.svelte"),
        server: () => import("./cinemas/AlternativesCinema.server.ts"),
    }),
    defineRoute({
        path: "/bouncelayer",
        component: () => import("./cinemas/BounceLayerCinema.svelte"),
        server: () => import("./cinemas/BounceLayerCinema.server.ts"),
    }),
    defineRoute({
        path: "/complementary",
        component: () => import("./cinemas/ComplementaryCinema.svelte"),
        server: () => import("./cinemas/ComplementaryCinema.server.ts"),
    }),
    defineRoute({
        path: "/productline",
        component: () => import("./cinemas/ProductLineCinema.svelte"),
        server: () => import("./cinemas/ProductLineCinema.server.ts"),
    }),
    defineRoute({
        path: "/trend/health",
        methods: {
            GET(_: Params, ctx: LoadContext) {
                ctx.json({ status: 200, body: JSON.stringify({ status: "ok" }) });
            }
        }
    }),
    defineRoute({
        path: '/internal/prometheus',
        methods: () => import('./services/observability/Prometheus.ts')
    })
];
